<template>
  <div class="row">
    <div class="col-lg-10 col-xl-8">
      <nav class="site-navigation"
           v-resize-text="{ratio:1.2, delay: 0}">
        <ul class="list-unstyled mb-4 mb-md-5">
            <li class="list-item text-light">
                <ul class="list-inline">
                    <li class="list-inline-item"
                        v-if="infoPage">
                      <router-link class="list-item-link inverted"
                                   :to="{ name: 'page', params: { slug: infoPage.slug } }">
                        <span v-html="infoPage.title.rendered"></span>
                        <span class="klavika">D</span>
                      </router-link>
                    </li>
                    <li class="list-inline-item">
                      Ontwerpt
                    </li>
                </ul>
            </li>
            <li class="list-item"
                v-bind:key="item.id"
                v-for="item in catalogs">
              <router-link class="list-item-link"
                           :to="{ name: 'catalog', params: { slug: item.slug } }">
                <span v-html="item.title.rendered"></span>
                <span class="klavika">D</span>
              </router-link>
            </li>
            <li class="list-item text-light">
              Voor
            </li>
            <li class="list-item"
                v-bind:key="item.id"
                v-for="item in clients">
              <router-link class="list-item-link"
                           :to="{ name: 'client', params: { slug: item.slug } }">
                <span v-html="item.title.rendered"></span>
                <span class="klavika">D</span>
              </router-link>
            </li>
        </ul>
        <ul class="list-unstyled mb-0">
          <li class="list-item"
              v-if="contactPage">
            <router-link class="list-item-link inverted"
                         :to="{ name: 'page', params: { slug: infoPage.slug } }">
              <span v-html="contactPage.title.rendered"></span>
              <span class="klavika">D</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'site-navigation',
  data () {
    return {
      infoPage: false,
      contactPage: false
    }
  },
  computed: {
    ...mapState({
      catalogs: state => state.catalogs,
      clients: state => state.clients,
      options: state => state.options
    })
  },
  beforeMount () {
    if (this.options.info) {
      this.infoPage = this.$store.getters.getItemById('page', this.options.info)
    }
    if (this.options.contact) {
      this.contactPage = this.$store.getters.getItemById('page', this.options.contact)
    }
  }
}
</script>
